import { ICON__upload } from '@/assets/icons_fa';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph';
import { upload_image_single } from '@/utils/utils_upload';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_IMAGE__view_upload({ field }: PROPS) {
  /*
   * STORE
   */

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * STATE
   */
  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * EVENTS
   */

  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    if (is_disabled()) return;

    upload_image_single(toast, file_data => FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph(file_data, field), t_base_ui);
  }

  /*
   * METHODS
   */
  function is_disabled(): boolean {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  if (!field.is_ready_for_manual_edit()) return null;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return null;

  assert_equal(field.category, ENUM__image_asset_category.IMAGE);

  return (
    <div
      onMouseEnter={() => set_is_hovered(true)}
      onMouseLeave={() => set_is_hovered(false)}
      className={`flex-center flex-col  size-full
        text-component-item
        border 
        ${is_disabled() ? 'cursor-not-allowed' : 'cursor-pointer'}
        ${is_hovered && 'text-component-item-foreground'}
        ${is_hovered && 'border-2 border-component-item-border'}
        transition-colors rounded`}
      {...{ onClick }}
    >
      <ICON__upload className={`!size-6  mb-1`} />
      <span className="text-xs ">Click to upload</span>
    </div>
  );
}
